import { vservice } from '@niknevis/vue-modules'
import { AdminTransactionRoute } from '@/modules/transaction/routes/admin.transaction.route'

@vservice()
export class AdminTransactionService {
  constructor(
    private readonly routes: AdminTransactionRoute
  ) {
  }

  setPaid(id: number) {
    return Inertia.put(
      this.routes.setPaid(id)
    )
  }

  reject(id: number, data: string) {
    return Inertia.put(
      this.routes.reject(id),
      { reason: data }
    )
  }

}